import React, { HTMLAttributes } from "react";
import classNames from "classnames";

import FormGroup from "./elements/FormGroup";
import { StyledForm } from "./Form.styled";

const FormComp = React.forwardRef<HTMLFormElement, HTMLAttributes<HTMLFormElement>>((props, ref) => {
  const { className, ...restProps } = props;
  const labelClass = classNames("c-form", className);

  return <StyledForm ref={ref} className={labelClass} {...restProps} data-testid="qa-form" />;
});

const Form = Object.assign(FormComp, { Group: FormGroup });

export default Form;
